<template>
  <div>
    <!-- No Disaster Message -->
    <!-- {{ Disaster.length }} -->
    <div
      v-if="Disaster.length <= 0"
      class="flex h-[200px] p-10 px-5 flex-col justify-center items-center gap-[9px] self-stretch border border-[#d3d3d3] bg-white"
    >
      <ShieldIcon />
      <p class="PC_Body1-R text-[#8D8D8D]">ขณะนี้ยังไม่มีเหตุภัยพิบัติ</p>
    </div>

    <!-- Disaster Section -->
    <div v-else>
      <div
        class="min-h-[200px] rounded-[10px] h-full border-[1px] border-[#B7B2B5] bg-white p-[20px]"
      >
        <!-- Header -->
        <div
          class="flex flex-col md:flex-row justify-between md:items-center w-full"
        >
          <div>
            <div class="title text-[#1F1D1F]">ประกาศเหตุฉุกเฉิน</div>
          </div>

          <div
            class="flex flex-col md:flex-row items-end md:items-center justify-end gap-[12px] sm:gap-[20px] mt-[10px] md:mt-0"
          >
            <div class="text-right">
                  <div v-if="userData.province_name_th == 'กรุงเทพมหานคร'" class="text-[#1F1D1F] important-M">
                {{ `จังหวัด${userData.province_name_th}` }}
              </div>
              <div v-else class="text-[#1F1D1F] important-M">
              <!-- {{ userData.province_name_th }} -->
                {{ `จังหวัด${userData.province_name_th}` }}
              </div>
              <!-- <div class="body text-[#1F1D1F]">ประกาศเมื่อ : 29-12-2568</div> -->
            </div>

            <button
              v-if="$route.path !== '/home-page' && auth.hasRole([ROLES.admin])"
              class="flex px-[16px] rounded-md md:w-auto border border-[#D3D3D3] justify-center items-center bg-[#9A247B] text-white min-h-[50px] disabled:bg-[#DFDCDD] disabled:text-[#B7B2B5]"
              @click="$router.push('/subDashboard')"
              :disabled="disasters.length === 0"
            >
              <EditIcon />
              <div class="ml-[5px] M">อัปเดต และแก้ไขข้อมูลเหตุฉุกเฉิน</div>
            </button>
          </div>
        </div>

        <!-- Filters -->
        <!-- {{ OptionDisater }} -->
        <div
          v-if="disastersRaw.length != 0"
          class="pt-[20px] pb-[16px] flex flex-col md:flex-row gap-[6px]"
        >
          <SelectBoxComponent
            :selectContainerClass="'w-full sm:max-w-[151px]'"
            :inputId="'filter1'"
            :searchable="true"
            :allowEmpty="true"
            :isFilter="true"
            :keyValue="'id'"
            :keyName="'name'"
            :options="[
              { id: '', name: 'แสดงทุกภัยพิบัติ' },
              { id: 1, name: 'อุทกภัย' },
              { id: 2, name: 'ดินถล่ม' },
              { id: 3, name: 'ไฟป่า' },
              { id: 4, name: 'หมอกควัน' },
              { id: 5, name: 'พายุฤดูร้อน' },
              { id: 6, name: 'แผ่นดินไหว' },
              { id: 7, name: 'อัคคีภัย' },
              { id: 8, name: 'โรคระบาด' },
            ]"
            :value="filters.disaster_id"
            :placeholder="'แสดงทุกภัยพิบัติ'"
            @update:modelValue="
              (res) => {
                filters.disaster_id = res;
                filters.page = '';
                getDiasaterWithFilters();
              }
            "
          />
          <SelectBoxComponent
            :selectContainerClass="'w-full sm:max-w-[141px]'"
            :inputId="'filterDistrictSelector'"
            :isFilter="true"
            :searchable="true"
            :allowEmpty="true"
            :keyValue="'districtCode'"
            :keyName="'districtNameTh'"
            :value="filters.district_id"
            :placeholder="'แสดงทุกอำเภอ'"
            :provinceCode="57"
            @update:modelValue="
              (res) => {
                filters.district_id = res;
                filters.page = '';
                getDiasaterWithFilters();
              }
            "
          />
          <SelectBoxComponent
            :selectContainerClass="'w-full sm:max-w-[151px]'"
            :inputId="'filterSort'"
            :isFilter="true"
            :keyValue="'value'"
            :keyName="'name'"
            :options="[
              {
                name: 'แสดงข้อมูลล่าสุด',
                value: 'desc',
              },
              {
                name: 'แสดงข้อมูลเก่าสุด',
                value: 'asc',
              },
            ]"
            :value="filters.sort"
            :placeholder="'แสดงข้อมูลล่าสุด'"
            @update:modelValue="
              (res) => {
                filters.sort = res;
                getDiasaterWithFilters();
              }
            "
          />
        </div>

        <!-- Disaster Cards -->
        <div
          v-if="disasters.length === 0"
          class="mt-[20px] h-[200px] w-full rounded-[6px] text-center py-[40px] text-black place-self-center place-items-center border border-[#DFDCDD]"
        >
          <div class="flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="62"
              height="70"
              viewBox="0 0 62 70"
              fill="none"
            >
              <g clip-path="url(#clip0_11085_185021)">
                <path
                  d="M61.5432 5.50125V10.5312C53.2487 17.2901 29.5348 36.6129 24.7243 40.5325C19.3919 36.4496 1.59559 22.824 0 21.6025V5.50125C0 5.50125 11.9442 0.5 30.7718 0.5C49.5994 0.5 61.5436 5.50125 61.5436 5.50125H61.5432Z"
                  fill="#44C19A"
                />
                <path
                  d="M24.7288 54.9297C25.2423 54.4028 49.9408 29.2979 61.5447 17.499V26.05C61.5447 62.8722 30.7729 69.8881 30.7729 69.8881C30.7729 69.8881 1.2394 63.1546 0.0390625 28.2583C7.24357 36.0421 23.8117 53.9305 24.7288 54.9297Z"
                  fill="#298472"
                />
                <path
                  d="M24.7274 54.9297C24.7157 54.9418 24.7161 54.9414 24.7274 54.9297V54.9297Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_11085_185021">
                  <rect
                    width="62"
                    height="69"
                    fill="white"
                    transform="translate(0 0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="mt-[9px] label text-[#7C7379]">
            ขณะนี้ยังไม่มีเหตุฉุกเฉิน
          </div>
        </div>

        <div
          class="grid grid-cols-1 md:grid-cols-2 gap-[16px] sm:gap-[12px] items-stretch"
        >
          <div
            v-for="(disaster, index) in disasters"
            :key="index"
            class="rounded-[8px] p-[10px] text-white flex flex-col h-full border border-[#B7B2B5]"
            :style="{ backgroundColor: getLevelColor(disaster.level).cardBg }"
          >
            <!-- Header -->
            <div class="flex w-full items-start mb-4">
              <span class="text-black"> </span>
              <img
                :src="disaster.image"
                alt="disaster.title"
                class="w-[80px] h-[80px] object-cover shrink-0"
              />
              <div class="flex-1 min-w-0 ml-[16px] mr-[12px]">
                <div
                  class="title-18"
                  :style="{ color: getLevelColor(disaster.level).title }"
                >
                  {{ disaster.disaster_name }}
                </div>
                <div
                  class="tag mt-1 px-2 py-1 rounded-[4px] w-full block whitespace-normal break-words"
                  :style="{
                    backgroundColor: getLevelColor(disaster.level).tagBg,
                    color: getLevelColor(disaster.level).tagText,
                  }"
                >
                  {{ levelMap[disaster.level] || `ระดับ ${disaster.level}` }}
                </div>
              </div>

              <button
                class="shrink-0 self-center border border-[#B7B2B5] bg-white min-h-[46px] text-[#1F1D1F] px-4 py-2 rounded-[6px] ButtonS hidden md:inline-block"
                @click="commandGIS(disaster.gis_maps)"
              >
                GIS Map
              </button>
            </div>
            <div class="">
              <button
                class="w-full shrink-0 self-center border border-[#B7B2B5] bg-white min-h-[46px] text-[#1F1D1F] px-4 py-2 rounded-[6px] ButtonS inline-block md:hidden"
                @click="commandGIS(disaster.gis_maps)"
              >
                GIS Map
              </button>
            </div>

            <div class="h-[1px] w-full bg-[#B7B2B5] my-[16px]"></div>

            <!-- Body (stretch) -->
            <div
              class="bg-white rounded-[8px] p-[10px] text-[#1F1D1F] flex flex-col flex-1"
            >
              <!-- เนื้อหาด้านบน: ให้กินที่ว่าง -->
              <div class="flex-1">
                <div
                  class="PC_Body1-R flex items-center flex-wrap gap-[10px] gap-y-[4px]"
                >
                  พื้นที่ที่ได้รับผลกระทบ
                  <span class="PC_Body1-SB">:</span>
                  <span class="PC_Body1-SB w-full sm:w-fit">{{
                    disaster.gis_map
                  }}</span>
                </div>
                <!-- <div class="PC_Body1-SB">
                  {{ disaster.gis_map }}
                </div> -->

                <div class="my-[6px] flex items-center gap-[10px]">
                  <span class="PC_Body1-R">ประกาศเมื่อ</span>
                  <span class="PC_Body1-SB">:</span>
                  <span class="PC_Body1-R">{{
                    formatThaiDate(disaster.created_at)
                  }}</span>
                </div>
                <div class="flex items-center gap-[10px]">
                  <span class="PC_Body1-R">อัปเดตล่าสุด</span>
                  <span class="PC_Body1-SB">:</span>
                  <span class="PC_Body1-R">{{
                    formatThaiDate(disaster.updated_at)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Pagination -->
        <div v-if="disastersRaw.length != 0" class="mt-[20px] sm:mt-[20px]">
          <PaginationComponent
            :items="itemsPost"
            @selectedPage="handlePagePost"
          />
        </div>

        <!-- Overview Section -->
        <div
          v-if="disastersRaw.length != 0"
          class="mt-[20px] px-[10px] py-[14px] bg-[#EECCE7] p-4 text-white border-t-2 border-t-[#9B237B]"
        >
          <div class="grid grid-cols-1 md:grid-cols-2 gap-[20px]">
            <div
              class="bg-[#FFF] flex flex-col py-[16px] px-[12px] rounded-[8px] w-full h-full border border-[#DFDCDD]"
            >
              <!-- ข้อมูลศูนย์พักพิง -->

              <div class="title text-[#1F1D1F]">ข้อมูลศูนย์พักพิง</div>
              <ButtonComponent
                :icon="'DownloadIcon'"
                :bClass="'btn_shadow--33 mt-[16px]'"
                :label="'ดาวน์โหลดรายงาน'"
                @clicked="download"
              />
              <div
                class="p-[10px] mt-[20px] bg-[#FBEFF8] text-[#1F1D1F] PC_Body1-R rounded-[6px] flex flex-col gap-[12px]"
              >
                <div class="flex items-center gap-[10px] flex-wrap">
                  <span class="text-[#9B237B]"> ศูนย์พักพิง (เปิดทำการ) </span>
                  <span>:</span>
                  <span class="ml-2 max-[481px]:ml-0">
                    {{ shelterDashboardData?.total_shelter }} แห่ง
                  </span>
                  <div class="max-[481px]:w-full">
                    <ButtonComponent
                      :icon="'ShelterIcon'"
                      :bClass="'btn_shadow--2 !min-w-[48px] !h-[48px]'"
                      :iClass="'!w-[24px] !h-[24px]'"
                      @clicked="openModal"
                    />
                  </div>
                </div>
                <hr />
                <div class="flex items-center gap-[10px] flex-wrap">
                  <span class="text-[#9B237B]">
                    จำนวนผู้ประสบภัย (ทุกศูนย์พักพิง)
                  </span>
                  <span>:</span>
                  <span> {{ shelterDashboardData?.total_population }} คน </span>
                </div>
                <div class="flex items-center gap-[10px] flex-wrap">
                  <span class="text-[#9B237B]"> อัปเดตล่าสุด </span>
                  <span>:</span>
                  <span>
                    {{
                      shelterDashboardData?.updated_at
                        ? formatThaiDate(shelterDashboardData.updated_at)
                        : "-"
                    }}
                  </span>
                </div>
              </div>
              <div class="text-[#1F1D1F] pt-[20px] PC_Body1-R">
                <SelectBoxComponent
                  :selectContainerClass="'w-full sm:max-w-[169px]'"
                  :inputId="'filterStatus'"
                  :isFilter="true"
                  :searchable="true"
                  :allowEmpty="true"
                  :keyValue="'id'"
                  :keyName="'name'"
                  :options="allShelterOptions"
                  :value="shelterId"
                  :placeholder="'แสดงทุกศูนย์พักพิง'"
                  :lengthOptionList="3"
                  @update:modelValue="
                    (res) => {
                      shelterId = res || null;
                      getShelter(shelterId);
                    }
                  "
                />
                <table class="mt-[10px]">
                  <tbody class="">
                    <tr class="">
                      <td class="text-[#9B237B]">ยอดผู้บาดเจ็บ</td>
                      <td class="px-2 py-1 flex items-center gap-[10px]">
                        <span>:</span>
                        <span>
                          {{ shelterDashboardData?.total_injuries }} คน
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-[#9B237B]">ยอดผู้เป็นปกติ</td>
                      <td class="px-2 py-1 flex items-center gap-[10px]">
                        <span>:</span>
                        <span>
                          {{ shelterDashboardData?.total_healthy }} คน
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-[#9B237B]">ยอดผู้เสียชีวิต</td>

                      <td class="px-2 py-1 flex items-center gap-[10px]">
                        <span>:</span>
                        <span>
                          {{ shelterDashboardData?.total_deaths }} คน
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- สาธารณประโยชน์ที่ได้รับความเสียหาย -->
            <div
              class="bg-[#FFF] py-[16px] px-[12px] flex flex-col gap-[20px] rounded-[8px] w-full border border-[#DFDCDD]"
            >
              <div class="title text-[#1F1D1F]">
                สาธารณประโยชน์ที่ได้รับความเสียหาย
              </div>
              <!-- <div v-if="auth.hasRole([ROLES.admin])" class="flex flex-wrap gap-[8px] justify-end">
                <button
                  class="flex rounded-md md:w-auto border border-[#D3D3D3] justify-center items-center px-4 py-2 bg-[#9A247B] text-white min-h-[50px] min-w-[229px]"
                  @click="updateDamagedUnits()"
                >
                  <AddIcon />
                  <div class="ml-[5px] M">เพิ่มสาธารณประโยชน์ที่ได้รับความเสียหาย</div>
                </button>
                <button
                  class="flex min-h-[50px]  rounded-md w-[165px] border border-[#D3D3D3] justify-center items-center px-4 py-1 bg-[#fff] text-[#1F1D1F] "
                  @click=""
                >
                  <div class="ml-[5px] M">ประวัติการอัปเดตข้อมูล</div>
                </button>
              </div>  -->
              <table class="table-fixed w-full">
                <tbody class="">
                  <tr v-for="damagedUnit of damagedUtilities" class="">
                    <td class="text-[#9B237B] w-[137px] pb-[10px] align-center">
                      {{ damagedUnit.name }}
                    </td>
                    <td class="text-[#1F1D1F] pb-[10px] align-center">
                      :&nbsp; {{ damagedUnit.total }} &nbsp;แห่ง
                    </td>
                    <td class="text-right p-0 pb-[10px] align-center">
                      <div class="flex w-full justify-end gap-[10px]">
                        <!-- <ButtonComponent
                        :icon="'TrashcanIcon'"
                        :bClass="'btn_shadow--2'"
                        @clicked="() => removeDamagedUnits(damagedUnit)"
                      /> -->
                        <!-- <button @click="removeDamagedUnits(damagedUnit)" :disabled="damagedUnit.total == 0"
                          class="flex items-center justify-center rounded-[6px] border border-[#B7B2B5] w-[48px] h-[48px] disabled:border-[#DFDCDD] disabled:text-[#DFDCDD] disabled:cursor-not-allowed">
                          <TrashcanIcon  :class="damagedUnit.total == 0 ? 'text-[#DFDCDD]':'text-primary' " class="w-[24px] h-[24px] " />
                        </button>
                        <button @click="updateDamagedUnits(damagedUnit)"
                          class="flex items-center justify-center rounded-[6px] border border-[#B7B2B5] w-[48px] h-[48px]">
                          <RefreshIcon class="w-[24px] h-[24px] text-primary" />
                        </button> -->
                        <button
                          @click="showDamagedUnits(damagedUnit)"
                          :disabled="damagedUnit.total == 0"
                          class="flex items-center justify-center rounded-[6px] border border-[#B7B2B5] w-[48px] h-[48px] disabled:border-[#DFDCDD] disabled:text-[#DFDCDD] disabled:cursor-not-allowed"
                        >
                          <InfoIcon
                            :class="
                              damagedUnit.total == 0
                                ? 'text-[#DFDCDD]'
                                : 'text-primary'
                            "
                            class="w-[24px] h-[24px]"
                          />
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Resource Request Section -->
          <div
            class="bg-[#FDFAFC] px-[10px] pt-[10px] pb-[16px] mt-[20px] rounded-[8px] border border-[#D3D3D3]"
          >
            <div class="title !text-[#1F1D1F]">การขอความช่วยเหลือ</div>
            <div
              class="flex flex-col md:flex-row gap-[10px] pt-[20px] label-L text-[#1F1D1F]"
            >
              <SelectBoxComponent
                :selectContainerClass="'md:max-w-[164px]'"
                :searchable="true"
                :allowEmpty="true"
                :isFilter="true"
                :inputId="'filter-type'"
                :keyValue="'id'"
                :keyName="'name'"
                :options="typeOption"
                :value="filtersCard2.type"
                :placeholder="'แสดงทุกประเภท'"
                @update:modelValue="onTypeChange"
              />
              <SelectBoxComponent
                :selectContainerClass="'md:max-w-[164px]'"
                :inputId="'filter-sort'"
                :isFilter="true"
                :keyValue="'action'"
                :keyName="'name'"
                :options="sortOption"
                :value="filtersCard2.sort"
                :placeholder="'แสดงรายการล่าสุด'"
                @update:modelValue="onSortChangeCard2"
              />
              <SearchBox
                id="filter-search"
                placeholder="ค้นหา ชื่อทรัพยากร"
                class="w-full h-[42px] md:w-4/6"
                v-model="selectedValue"
                @update:modelValue="onSearch"
              />
            </div>

            <!-- Resource Cards -->
            <!-- <div class="text-black">{{  cards2 }}</div> -->
            <div v-if="cards2.length <= 0" class="self-center">
              <div
                class="justify-items-center h-[390px] border border-[#B7B2B5] rounded-[6px] my-[20px] py-[40px] content-center"
              >
                <div class="justify-items-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="60"
                    height="57"
                    viewBox="0 0 60 57"
                    fill="none"
                  >
                    <path
                      d="M5.20275 9.97331H9.0967C10.0583 9.97331 10.8379 10.7529 10.8379 11.7145C10.8379 12.6761 10.0583 13.4556 9.0967 13.4556H5.20275C5.19857 13.4556 5.19462 13.4551 5.19056 13.4551L6.91037 17.5352C7.22959 17.1699 7.69761 16.9381 8.22078 16.9381H12.1147C13.0763 16.9381 13.8559 17.7177 13.8559 18.6793C13.8559 19.6409 13.0763 20.4205 12.1147 20.4205H8.22078C8.18827 20.4205 8.15659 20.4173 8.12455 20.4156L11.1147 27.5095H16.3195C16.1461 26.7183 16.0509 25.8788 16.0572 24.9806C16.0721 22.8458 16.7185 20.8569 17.8161 19.192C16.7206 17.7728 16.0667 15.9964 16.0667 14.069V10.4235C16.0667 9.64237 16.2888 8.91235 16.6724 8.29238L16.1494 7.0515C14.8563 3.85634 10.9581 2.29996 7.82135 3.73364C5.24349 4.80365 3.74643 7.66649 4.10825 10.3615C4.40726 10.119 4.78788 9.97331 5.20275 9.97331Z"
                      fill="#B7B2B5"
                    />
                    <path
                      d="M26.6749 14.3884C27.8934 14.3884 29.0775 14.5909 30.208 14.9917V14.7619C30.208 12.0452 28.0056 9.84277 25.2888 9.84277H20.1273C19.8067 9.84277 19.5469 10.1027 19.5469 10.4232V14.0687C19.5469 14.9879 19.7997 15.8478 20.2386 16.5839C22.0277 15.208 24.2605 14.3884 26.6749 14.3884Z"
                      fill="#B7B2B5"
                    />
                    <path
                      d="M40.4899 27.5092C40.7448 26.7333 40.887 25.9052 40.8808 25.0042C40.8535 21.0708 37.6516 17.8706 33.7432 17.8706C32.6814 17.8706 31.6594 18.0989 30.7056 18.5493L30.21 18.7833L29.7143 18.5493C28.7606 18.099 27.7387 17.8706 26.6769 17.8706C22.7686 17.8706 19.5667 21.0708 19.5393 25.0043C19.533 25.9052 19.6753 26.7333 19.9302 27.5092H40.4899Z"
                      fill="#B7B2B5"
                    />
                    <path
                      d="M44.3649 24.9803C44.371 25.8784 44.277 26.7183 44.1036 27.5094H52.0624V15.6236C52.0624 13.7776 50.8858 12.1404 49.1347 11.5496L48.345 11.2832V3.56559H48.403C49.3646 3.56559 50.1442 2.78601 50.1442 1.82442C50.1442 0.862832 49.3646 0.083252 48.403 0.083252H40.2109C39.2493 0.083252 38.4697 0.862832 38.4697 1.82442C38.4697 2.78601 39.2493 3.56559 40.2109 3.56559H40.269V11.2832L39.4793 11.5496C37.9968 12.0496 36.9265 13.2997 36.6328 14.7914C41.0589 16.0547 44.3312 20.1442 44.3649 24.9803Z"
                      fill="#B7B2B5"
                    />
                    <path
                      d="M59.4067 27.9701C58.7268 27.2901 57.6243 27.2901 56.9443 27.9701L53.9228 30.9916H6.52207L3.47235 27.9419C2.79237 27.2619 1.68986 27.2619 1.00999 27.9419C0.330004 28.6219 0.330004 29.7243 1.00999 30.4042L4.05971 33.454V54.287C4.05971 55.2486 4.83929 56.0281 5.80088 56.0281H54.644C55.6056 56.0281 56.3852 55.2486 56.3852 54.287V33.454L59.4067 30.4324C60.0867 29.7525 60.0867 28.6501 59.4067 27.9701ZM33.4316 45.3565H31.9496V46.8386C31.9496 47.8002 31.17 48.5798 30.2084 48.5798C29.2468 48.5798 28.4672 47.8002 28.4672 46.8386V45.3565H26.9851C26.0235 45.3565 25.244 44.5769 25.244 43.6153C25.244 42.6537 26.0235 41.8742 26.9851 41.8742H28.4672V40.3921C28.4672 39.4305 29.2468 38.6509 30.2084 38.6509C31.17 38.6509 31.9496 39.4305 31.9496 40.3921V41.8742H33.4316C34.3932 41.8742 35.1728 42.6537 35.1728 43.6153C35.1728 44.5769 34.3932 45.3565 33.4316 45.3565Z"
                      fill="#B7B2B5"
                    />
                  </svg>
                  <div
                    class="text-[#7C7379] PC_Body1-R place-self-center mt-[9px]"
                  >
                    ขณะนี้ยังไม่มีข้อมูล
                  </div>
                </div>
              </div>
            </div>
            <div
              class="mt-[20px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[8px]"
            >
              <div
                v-for="(card, index) in cards2"
                :key="index"
                class="border p-[10px] border-[#B7B2B5] rounded-[6px] flex flex-col flex-grow min-h-[191px]"
              >
                <div class="relative mb-[10px] flex gap-2">
                  <div class="border border-[#F2E7F9] h-[48px] w-[48px]">
                    <img
                      :src="card?.image_path"
                      alt="Card Image"
                      class="min-h-[48px] min-w-[48px] border border-[#DFDCDD]"
                    />
                  </div>
                  <div
                    class="h-[72px] flex flex-col items-start gap-[4px] flex-1 min-w-0"
                  >
                    <div
                      class="text-[#1F1D1F] truncate overflow-hidden whitespace-nowrap w-full"
                    >
                      {{ card?.name }}
                    </div>
                    <div
                      class="text-[#7C7379] label-L !text-[13px] truncate overflow-hidden whitespace-nowrap w-full"
                    >
                      {{ card?.unit_name }}
                    </div>
                    <div
                      class="text-[#7C7379] label-L !text-[13px] truncate overflow-hidden whitespace-nowrap w-full"
                    >
                      {{ card?.category_name }}
                    </div>
                  </div>

                  <!-- <div class="absolute top-0 right-0 flex"> -->
                  <!-- <div class="text-black">{{  card.id }}</div> -->
                  <button
                    class="cursor-pointer px-[8px] flex justify-center items-center rounded-[6px] border-[#B7B2B5] border w-[42px] h-[42px] text-[#9B237B]"
                    @click="openListShelter(card)"
                  >
                    <ShelterIcon />
                  </button>
                  <!-- </div> -->
                </div>

                <!-- <div v-if="card?.needed" class="mt-[0px]"> -->
                <!-- <div class="text-black">{{ card }}</div> -->
                <div>
                  <div
                    class="w-full bg-[#EECCE7] rounded-full h-[4px]"
                    :class="
                      card?.needed === 'ไม่จำกัด'
                        ? 'bg-[#F3F2F2]'
                        : 'bg-[#EECCE7]'
                    "
                  >
                    <div
                      class="bg-[#9B237B] h-[4px] rounded-full"
                      :style="{ width: calculateProgressWidth(card) }"
                    ></div>
                  </div>
                  <!-- <div class="text-black">{{ card }}</div> -->
                  <!-- <p class="text-main-black mt-1 text-right PC_Body2-R">
                    {{ card.current }}/{{ card.total }}
                  </p> -->
                  <div
                    class="text-[#9B237B] bg-[#FBEFF8] mt-[10px] px-[4px] PC_Body2-R h-[29px] content-center"
                  >
                    ต้องการอีก :
                    {{
                      card?.needed === "-1"
                        ? "ไม่จำกัด"
                        : formatNumber(card?.needed)
                    }}
                  </div>
                  <div
                    :class="[
                      'text-[#1F1D1F] label-L text-right !text-[13px]',
                      { invisible: card?.needed == '-1' },
                    ]"
                  >
                    <!-- :class="{ invisible: card.needed === 'ไม่จำกัด' }"" -->
                    <div>
                      ยอดร้องขอ : {{ formatNumber(card?.total_request) }}
                    </div>
                    <div>
                      ยอดที่ได้รับ : {{ formatNumber(card?.total_quantity) }}
                    </div>
                  </div>
                  <hr class="my-[10px]" />
                  <div class="text-[#1F1D1F] label-L flex justify-between">
                    <div class="!text-[13px]">
                      อัปเดตเมื่อ {{ formatDateToThai(card.updated_at) }}
                    </div>
                    <div class="text-right label-L !text-[13px]">
                      {{ formatTime(card.updated_at) }}
                    </div>
                  </div>
                </div>
                <!-- </div> -->
              </div>
            </div>

            <!-- Pagination -->
            <div class="mt-[16px]">
              <PaginationComponent :items="items" @selectedPage="handlePage" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <ListSheltersModal
      :is-open="isModalOpen"
      :shelters="sheltersList"
      :title="'รายการ Shelters ทั้งหมด'"
      @close="closeModal"
    />
    <ListShelterHelpModal
      ref="ListShelterStatusRef"
      :data="shelterData"
      v-if="ListShelterStatus"
      @close="closeModalShelter"
    />
    <DamagedUnitsInfoModal ref="damagedUnitsInfoModalRef" />
    <DamageUnitUpdateModal
      ref="damageUnitUpdateModal"
      @close="handleCloseDamageUnitUpdateModal"
    />
    <DownloadReportModal ref="DownloadReportModalRef" />
    <StatusModal ref="statusModalRef" @submit="cfDeleteModal" />
  </div>
</template>

<script setup>
import {
  ref,
  computed,
  watch,
  onMounted,
  onUnmounted,
  onActivated,
  onDeactivated,
  nextTick,
} from "vue";
import { useRoute } from "vue-router";
import axios from "axios";
import ListSheltersModal from "../../Modals/ListSheltersModal.vue";
import ShieldIcon from "@/assets/icons/Shield.icon.vue";
import ListShelterHelpModal from "../../Modals/ListShelterHelpModal.vue";
import DamagedUnitsInfoModal from "../../Modals/DamagedUnitsInfoModal.vue";
import DamageUnitUpdateModal from "../../Modals/DamageUnitUpdateModal.vue";

import { storeToRefs } from "pinia";
import { useShelterStore } from "@/pinia/shelter";
import { useDisaterRequestStore } from "@/pinia/disater";
import { useRequestHelpStore } from "@/pinia/requestHelp";
import { useProductStore } from "@/pinia/product";
import { useEmcRequestStore } from "@/pinia/emcRequest";
import { useAuthStore } from "@/pinia/authStore";
import "@/pinia/echo";
// โรล
import { ROLES } from "@/components/Utilities/javascripts/permissions";

const route = useRoute();

const shelterStore = useShelterStore();
const disaterStore = useDisaterRequestStore();
const requestHelpStore = useRequestHelpStore();
const productStore = useProductStore();
const emcRequestStore = useEmcRequestStore();
const auth = useAuthStore();
const { user_province_name, userData } = storeToRefs(auth);

// Data
const { AllShelter } = storeToRefs(shelterStore);

const allShelterOptions = computed(() => {
  const list = Array.isArray(AllShelter.value) ? AllShelter.value : [];
  const normalized = list
    .map((s) => ({
      id: s?.id ?? s?.shelter_id ?? s?.value ?? s?.code,
      name: s?.name ?? s?.shelter_name ?? s?.label ?? s?.title,
    }))
    .filter((x) => x.name); // กันค่าพัง

  return [{ id: null, name: "แสดงทุกศูนย์พักพิง" }, ...normalized];
});

const Disaster = ref([{ name: "ดินถล่ม" }]);
const ListShelterStatus = ref(false);
const shelterData = ref({
  name: "",
});
const statusModalRef = ref("");
const isModalOpen = ref(false);

const sheltersList = ref([
  {
    name: "ศูนย์อพยพเมือง 2",
    current: 278,
    capacity: 300,
    phone: "0653456789",
  },
]);
const items = ref(null);
const itemsPost = ref(null);

const filters = ref({
  disaster_id: undefined, // ไม่ใส่ = แสดงทุกภัยพิบัติ
  district_id: undefined, // ไม่ใส่ = แสดงทุกอำเภอ
  sort: "desc", // ค่าเริ่มต้น “แสดงข้อมูลล่าสุด”
  page: 1, // number
  pagination: 10,
});

const filter = ref({
  page: 1,
  search: "",
});
const currentPage = ref(1);
const currentPagePost = ref(1);
const itemsPerPage = ref(8);
const selectedValue = ref("");
const damagedUnitsInfoModalRef = ref(null);
const damageUnitUpdateModal = ref(null);

const OptionDisater = ref([
  "แสดงทุกภัยพิบัติ", //ไม่ต้องส่ง
  "อุทกภัย", //2
  "ดินถล่ม", //3
  "ไฟป่า", //4
  "หมอกควัน", //5
  "พายุฤดูร้อน", //6
  "แผ่นดินไหว", //7
  "อัคคีภัย", //8
  "โรคระบาด", //9
]);

const disasterNameToId = {
  อุทกภัย: 1,
  ดินถล่ม: 2,
  ไฟป่า: 3,
  หมอกควัน: 4,
  พายุฤดูร้อน: 5,
  แผ่นดินไหว: 6,
  อัคคีภัย: 7,
  โรคระบาด: 8,
};

const shelterDashboardData = ref(null);

const typeOption2 = [
  { id: 1, name: "แสดงทุกประเภท", action: null },
  { id: 2, name: "ของใช้", action: "ของใช้" },
  { id: 3, name: "อาหาร", action: "อาหาร" },
];

const typeOption = ref([]);

const sortOption = [
  { id: 1, name: "แสดงรายการล่าสุด", action: "desc" },
  { id: 2, name: "แสดงรายการเก่าสุด", action: "asc" },
];

const filtersCard2 = ref({
  type: null, // 'อาหาร' | 'ของใช้' | null
  sort: "desc", // 'desc' | 'asc'
  search: "", // string
  page: 1, // number
  pagination: 8,
});

const cards2 = ref([]);

const disasters = ref([]);
const disastersRaw = ref([]);

const getLevelColor = (level) => {
  const colorMap = {
    1: {
      cardBg: "#FFF",
      tagBg: "#D5F6B3",
      tagText: "#3B5C1C",
      title: "#1F1D1F",
    },
    2: {
      cardBg: "#FFF",
      tagBg: "#A0DBF4",
      tagText: "#204B5D",
      title: "#1F1D1F",
    },
    3: {
      cardBg: "#FFF",
      tagBg: "#F4D69F",
      tagText: "#5D4820",
      title: "#1F1D1F",
    },
    4: {
      cardBg: "#FFF",
      tagBg: "#F5BD9F",
      tagText: "#5D361F",
      title: "#1F1D1F",
    },
    5: {
      cardBg: "#FFF",
      tagBg: "#F49F9F",
      tagText: "#5D1F1F",
      title: "#1F1D1F",
    },
  };
  return colorMap[level] || colorMap[1]; // ถ้าไม่เจอใช้ระดับ 1 (สีม่วง)
};

const damagedUtilities = ref([]);

// Computed
// const totalItems = computed(() => cards.value.length);
// const totalPages = computed(() =>
//   Math.ceil(totalItems.value / itemsPerPage.value)
// );

// const startItem = computed(() =>
//   totalItems.value === 0 ? 0 : (currentPage.value - 1) * itemsPerPage.value + 1
// );

// const endItem = computed(() => {
//   const end = currentPage.value * itemsPerPage.value;
//   return end > totalItems.value ? totalItems.value : end;
// });

// const paginatedCards = computed(() => {
//   const start = (currentPage.value - 1) * itemsPerPage.value;
//   const end = start + itemsPerPage.value;
//   return cards.value.slice(start, end);
// });

// const visiblePages = computed(() => {
//   const total = totalPages.value;
//   const current = currentPage.value;
//   const pages = [];

//   if (total <= 4) {
//     for (let i = 1; i <= total; i++) {
//       pages.push(i);
//     }
//   } else {
//     if (current <= 2) {
//       pages.push(1, 2, "...", 3, 4);
//     } else if (current >= total - 1) {
//       pages.push(total - 3, total - 2, "...", total - 1, total);
//     } else {
//       pages.push(current - 2, current - 1, "...", current, current + 1);
//     }

//     const seen = new Set();
//     return pages.filter((p) => {
//       if (typeof p === "number" && (p < 1 || p > total)) return false;
//       const key = typeof p === "string" ? p : `page-${p}`;
//       if (seen.has(key)) return false;
//       seen.add(key);
//       return true;
//     });
//   }

//   return pages;
// });

function formatThaiDate(isoString) {
  const date = new Date(isoString);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear() + 543;
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");
  return `${day}-${month}-${year} ${hours}:${minutes}`;
}

const CHANNEL = "Product";
const EVENT = ".page.refresh";

let channel = null;
let isListening = false;

const handleRefresh = (e) => {
  // console.log("🔥 Refresh event:", e);
  getRequestHelp();
};

const subscribe = () => {
  if (isListening) return;
  channel = Echo.channel(CHANNEL);
  channel.listen(EVENT, handleRefresh);
  isListening = true;
  // console.log("✅ subscribed to", CHANNEL, EVENT);
};

const unsubscribe = () => {
  if (!isListening) return;
  try {
    Echo.leave(CHANNEL);
  } catch (err) {
    console.warn("unsubscribe error:", err);
  }
  channel = null;
  isListening = false;
  // console.log("🧹 unsubscribed");
};

onActivated(async () => {
  subscribe();
  await getRequestHelp();
  // console.log("✅ data reloaded:", cards2.value.length);
});

onDeactivated(unsubscribe);

watch(
  () => route.query.ts,
  () => {
    popup();
  }
);

//onMounted
onMounted(async () => {
  // pusher ย้ายไไปในฟังชัน subscribe แล้วครับ
  subscribe();
  // Echo.channel("Product").listen(".page.refresh", (e) => {
  //   console.log("Refresh event:", e);
  //   // action refresh หน้า
  //   // ออกหลังได้ event
  //   getRequestHelp();
  // });

  // จนกว่าจะเชื่อม Notify
  // Echo.channel("App.Models.User.1").listen(".user.notification", (e) => {
  //   console.log("Refresh event:", e);
  //   // action refresh หน้า
  //   // ออกหลังได้ event
  //   getRequestHelp();
  // });

  // popup
  popup();
  // popup
  await getDamagedUtilities();
  await getCategory();
  await shelterStore.getAllShelter();
  await getDiasaterWithFilters();
  // await getDiasater();
  await getShelter();
  await getRequestHelp();
  await getDiasaterWithFiltersRaw();
});

onUnmounted(unsubscribe);
// Methods
const popup = async () => {
  // console.log("sdf");

  const popup = await JSON.parse(localStorage.getItem("popup"));
  if (!popup) return;
  if (popup.popup_name == "created") {
    openListShelter(popup);
  }
  localStorage.removeItem("popup");
};

async function getCategory() {
  try {
    const s = await productStore.getAllProductType();
    // console.log("getCategory :", s.data.data);

    // map data ที่ backend ส่งมาให้เป็น {id, name, action}
    const categories = s.data.data.map((item) => ({
      id: item.id,
      name: item.name,
      action: item.id,
    }));

    // ใส่ "แสดงทุกประเภท" ไว้ข้างหน้าเสมอ
    typeOption.value = [
      { id: 0, name: "แสดงทุกประเภท", action: null },
      ...categories,
    ];
  } catch (error) {
    console.error(error);
    throw error;
  }
}
async function getDamagedUtilities() {
  await axios
    .get("/damaged-utilities")
    .then((res) => {
      damagedUtilities.value = res.data.data;
    })
    .catch((err) => {
      // console.log(err);
    });
}
// async function getDiasater() {
//   const s = await disaterStore.getDiasater();
//   disasters.value = s.data.data;
//   console.log("getDiasater : ", disasters.value);
// }

async function getShelter(query = null) {
  const formattedQuery = query !== null ? { shelter_id: query } : null;

  const s = await disaterStore.getShelterDashboard(formattedQuery);
  shelterDashboardData.value = s.data;
  // console.log("getShelterDashboard:", shelterDashboardData.value);
}

async function getRequestHelp() {
  const params = {};
  if (filtersCard2.value.search && filtersCard2.value.search.trim() !== "") {
    params.search = filtersCard2.value.search.trim(); // คีย์ชื่อที่ backend ใช้อยู่แล้ว
  }
  if (filtersCard2.value.type) {
    params.category_id = filtersCard2.value.type; // ถ้า backend ใช้คีย์อื่น เปลี่ยนตรงนี้
  }
  if (filtersCard2.value.sort) {
    params.sort = filtersCard2.value.sort; // 'desc' | 'asc'
  }
  if (filtersCard2.value.page) {
    params.page = filtersCard2.value.page;
  }
  if (filtersCard2.value.pagination) {
    params.paginate = filtersCard2.value.pagination;
  }

  const s = await requestHelpStore.getProductRequest(params);
  cards2.value = s.data.data;

  // ถ้ามีเพจิเนชันจากแบ็กเอนด์ ก็อัปเดต items ที่นี่ด้วย
  items.value = s.data;
  // console.log("getRequestHelp params:", params, "data:", s.data.data);
  // console.log("✅ cards2 length:", cards2.value.length);
}

// ===== Handlers สำหรับตัวกรอง =====
function onTypeChange(option) {
  // option = 'อาหาร' | 'ของใช้' (หรือ undefined ถ้าเคลียร์)
  filtersCard2.value.type = option ?? null;
  filtersCard2.value.page = 1;
  getRequestHelp();
}

function onSortChangeCard2(res) {
  filtersCard2.value.sort = res || "desc";
  filtersCard2.value.page = 1;
  getRequestHelp();
}

function onSearch(val) {
  filtersCard2.value.search = val || "";
  filtersCard2.value.page = 1;
  getRequestHelp();
}

async function getDiasaterWithFilters() {
  // กรองคีย์ที่เป็น undefined ออก
  const params = {};
  if (filters.value.disaster_id !== undefined)
    params.disaster_id = filters.value.disaster_id;
  if (filters.value.district_id !== undefined)
    params.district_id = filters.value.district_id;

  // ถ้า sort ไม่มีค่า → ใส่ desc ไปเลย
  params.sort = filters.value.sort || "desc";
  params.page = filters.value.page;
  params.paginate = filters.value.pagination;

  // เรียกของจริง
  const s = await disaterStore.getDiasater(params);
  disasters.value = s.data.data;
  itemsPost.value = s.data;

  await getDiasaterWithFiltersRaw();
  // console.log("getDiasater : ", disasters.value, "params:", params);
}

async function getDiasaterWithFiltersRaw() {
  // กรองคีย์ที่เป็น undefined ออก
  const params = {};
  // ถ้า sort ไม่มีค่า → ใส่ desc ไปเลย
  params.sort = filters.value.sort || "desc";

  // เรียกของจริง
  const s = await disaterStore.getDiasater(params);
  disastersRaw.value = s.data.data;
}

const removeDamagedUnits = (damagedUnit) => {
  statusModalRef.value.openModal(
    "warning",
    {
      header: "คำเตือน !",
      subHeader:
        "ข้อมูลจะถูกล้างออกทั้งหมด ไม่สามารถกู้คืนได้ ท่านต้องการลบข้อมูลหรือไม่",
      closeButtonText: "ปิดหน้าต่าง",
      submitButtonText: "ลบ",
    },
    damagedUnit
  );
};

const cfDeleteModal = (damagedUnit) => {
  axios
    .delete("/damaged-utility/" + damagedUnit.id)
    .then((res) => {
      if (res.data.code == 200) {
        const idx = damagedUtilities.value.findIndex(
          (item) => item.id == damagedUnit.id
        );
        if (idx != -1) {
          damagedUtilities.value[idx].total = 0;
        }
        statusModalRef.value.openModal("success", {
          header: "ดำเนินการสำเร็จ !",
          subHeader: res.data.message,
          closeButtonText: "ปิดหน้าต่าง",
          timeout: 5000,
        });
      } else {
        statusModalRef.value.openModal("error", {
          header: "ดำเนินการไม่สำเร็จ !",
          subHeader: res.data.message,
          closeButtonText: "ปิดหน้าต่าง",
        });
      }
    })
    .catch((err) => {
      // console.log(err);
      statusModalRef.value.openModal("error", {
        header: "ดำเนินการไม่สำเร็จ !",
        subHeader: res.data.message,
        closeButtonText: "ปิดหน้าต่าง",
      });
    });
};
const updateDamagedUnits = (damagedUnit) => {
  // damagedUnitsInfoModalRef.value.openModal(damagedUnit);
  // console.log(" showDamagedUnits : ", damagedUnit);
  damageUnitUpdateModal.value.openModal(damagedUnit);
};

const showDamagedUnits = (damagedUnit) => {
  // console.log(" showDamagedUnits : ", damagedUnit);
  damagedUnitsInfoModalRef.value.openModal(damagedUnit, "", "", true);
};

const handleCloseDamageUnitUpdateModal = (payload) => {
  if (payload) {
    const index_payload = damagedUtilities.value.findIndex(
      (item) => item.id == payload.type
    );
    if (index_payload != -1) {
      damagedUtilities.value[index_payload].total = payload.newTotal;
    }
  }
};

function calculateProgressWidth(card) {
  if (!card.total_request || card.total_request === 0) return "0%";
  const current = parseFloat(String(card.total_quantity).replace(/,/g, ""));
  const total = parseFloat(String(card.total_request).replace(/,/g, ""));
  if (isNaN(current) || isNaN(total) || total === 0) return "0%";
  const percentage = (current / total) * 100;
  return percentage.toFixed(2) + "%";
}

function goToPage(page) {
  if (typeof page === "number" && page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
  }
}

function prevPage() {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
}

function nextPage() {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
}

function handleSearch(value) {
  // console.log("Search term:", value);
}

function openModal() {
  isModalOpen.value = true;
}

function closeModal() {
  isModalOpen.value = false;
}

function closeModalShelter() {
  ListShelterStatus.value = false;
}

async function openListShelter(data) {
  // console.log("data", data);

  ListShelterStatus.value = true;
  // const s = await requestHelpStore.getProductRequestById(data);
  // console.log('openListShelter: ', s);
  shelterData.value = {
    data,
  };
}
async function handlePage(page, perpage) {
  currentPage.value = page;
  filter.value.page = page;
  filtersCard2.value.page = page;
  filtersCard2.value.pagination = perpage;
  await getRequestHelp();
}

async function handlePagePost(page, perpage) {
  currentPagePost.value = page;
  filters.value.page = page;
  filters.value.pagination = perpage;
  await getDiasaterWithFilters();
}

function formatDateToThai(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear() + 543; // แปลงเป็น พ.ศ.
  return `${day}-${month}-${year}`;
}

function formatTime(dateString) {
  const date = new Date(dateString);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
}

function formatNumber(value) {
  if (value === null || value === undefined) return "-";
  if (isNaN(value)) return value; // ถ้าไม่ใช่ตัวเลข เช่น "ไม่จำกัด" ก็คืนค่าตรง ๆ
  return new Intl.NumberFormat("th-TH").format(value);
}

const shelterId = ref(null);

function commandGIS(data) {
  window.open(`${data}`, "_blank");
}

const levelMap = {
  1: "ระดับ 1 : สาธารณภัยขนาดเล็ก จัดการได้ภายในอำเภอ",
  2: "ระดับ 2 : จัดการได้ภายในจังหวัด",
  3: "ระดับ 3 : ระดับภาคหรือส่วนกลาง ระดับกรมเข้ามาช่วยจัดการ",
  4: "ระดับ 4 : ระดับชาติ",
  // 5: "ระดับ 5 : รุนแรงมาก ต้องใช้มาตรการพิเศษ"
};

const DownloadReportModalRef = ref(null);

const download = () => {
  if (shelterId.value != null) {
    DownloadReportModalRef.value.openModal(shelterId.value);
  } else {
    DownloadReportModalRef.value.openModal();
  }
};

onMounted(getDiasaterWithFilters);
defineExpose({ showDamagedUnits, getDiasaterWithFilters });
</script>

<style lang="scss" scoped>
.ButtonS {
  /* Button/s */
  font-family: Kanit;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 153.846% */
  letter-spacing: 0.1px;
}

@media screen and (max-width: 64rem) {
  .PC_Body1-R {
    font-size: 16px !important;
  }
}
</style>
